import React from 'react';
import PropTypes from 'prop-types';
import Text from 'antd/lib/typography/Text';
import Title from 'antd/lib/typography/Title';
import CustomIcon from 'components/Icons';
import ModalContainer from 'components/Common/ModalContainer';
import styles from './styles.module.less';

const ResetPasswordModal = ({ isOpen, onModalCancel }) => (
  <ModalContainer
    className={styles.modalReset}
    isOpen={isOpen}
    onCancel={onModalCancel}
    title=" "
  >
    <div className={styles.modalResetContainer}>
      <div className={styles.modalResetCheckContainer}>
        <CustomIcon type="check" />
      </div>
      <Title level={2}>Reset password link sent successfully</Title>
      <Text className={styles.modalResetText}>
        A reset password link has been sent to you via email. You can follow
        that link and select a new password. If the email is not in your inbox,
        please check your spam folder.
      </Text>
    </div>
  </ModalContainer>
);

ResetPasswordModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onModalCancel: PropTypes.func.isRequired,
};

export default ResetPasswordModal;
